/**
 * Routes where the AIInsightsWidget should be visible.
 *
 * Rules:
 *  - Exact match:  "/about-us"     → matches only /about-us
 *  - Prefix match: "/services/"    → matches /services and /services/anything
 *
 * Ghost Pages are handled separately via pageProps.component — no slug needed here.
 */
export const AI_INSIGHTS_PAGES: string[] = [
  "/", // Home
  "/services/", // Services landing + all sub-pages
  "/industries/", // Industries + all sub-pages
  "/solutions/", // Software Solutions + all sub-pages
  "/case-studies/", // Case Studies + all detail pages
];

/**
 * pageProps.component values that should always show the AI widget,
 * regardless of URL.
 */
export const AI_INSIGHTS_COMPONENT_TYPES: string[] = ["GhostPage"];
